const TYPES = {
    LOAD_ALL: 'LOAD_ALL',
    LOAD_ALL_SUCCESS: 'LOAD_ALL_SUCCESS',
    LOAD_ALL_ERROR: 'LOAD_ALL_ERROR',
};

const loadAll = (args) => ({
    type: TYPES.LOAD_ALL,
    args,
});

export {
    TYPES,
    loadAll,
};
